<script setup lang="ts">
import BaseLayout from "./base.vue";

const { t } = useI18n();

const route = useRoute();
const header = computed(() => (route?.meta.header ?? "Header") as string);
const subheader = computed(() => route?.meta.subheader as string | undefined);
</script>

<template>
  <base-layout>
    <template #header>
      <layout-page-header />
    </template>
    <template #subHeader>
      <h2 class="text-2xl font-semibold leading-8">{{ t(header) }}</h2>
      <p v-if="subheader" class="text-sm leading-6">{{ t(subheader) }}</p>
    </template>

    <slot />

    <template #footer>
      <version-footer />
    </template>
  </base-layout>
</template>
